/* import __COLOCATED_TEMPLATE__ from './option-item-entity-access-type.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();